var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LotsTableBase',{attrs:{"additional_fields":_vm.additional_fields,"bidding_type":_vm.bidding_type,"custom-sort-slice":_vm.customSortSlice,"disable-open-offers-for-lot":_vm.disableOpenOffersForLot,"group":_vm.group,"in_creating":_vm.in_creating,"lots_headers":_vm.lots_headers,"tender":_vm.tender}})
}
var staticRenderFns = []

export { render, staticRenderFns }